/* =========================================================
   PRO TUNE — comportamentos que antes ficavam dentro de arquivos do Horizon
   (product-form.js, video-background.js, blocks/menu.liquid)
   ========================================================= */
(function () {
  'use strict';

  // 1) Depois de adicionar ao carrinho pela página de produto, vai direto para o carrinho
  document.addEventListener('cart:update', function (e) {
    var d = e && e.detail && e.detail.data;
    if (d && d.source === 'product-form-component' && !d.didError) {
      window.location.href = '/cart';
    }
  });

  // 2) Vídeos de fundo (header da home): força o autoplay
  function playBgVideos() {
    document.querySelectorAll('video-background-component video').forEach(function (v) {
      v.muted = true;
      v.setAttribute('playsinline', '');
      if (v.paused) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
        v.addEventListener('canplay', function () {
          if (v.paused) { var q = v.play(); if (q && q.catch) q.catch(function () {}); }
        }, { once: true });
      }
    });
  }

  // 3) Link do Performance Cloud no menu abre em nova aba
  function externalMenuLinks() {
    document.querySelectorAll('a[href*="performance.protune.com.br"]').forEach(function (a) {
      a.setAttribute('target', '_blank');
      a.setAttribute('rel', 'noopener noreferrer');
    });
  }

  function init() { playBgVideos(); externalMenuLinks(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', playBgVideos);
  document.addEventListener('shopify:section:load', init);
})();
